import config from '../config';

/**
 * Retourne l'URL complète d'une image
 * Si l'URL est déjà complète (Cloudinary), la retourne telle quelle
 * Sinon, ajoute l'URL du backend devant
 */
export const getImageUrl = (url) => {
  if (!url) return null;
  
  // Si l'URL commence par http:// ou https://, c'est déjà une URL complète
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Sinon, ajouter l'URL du backend
  return `${config.API_URL}${url}`;
};
